const defaultTheme = {
  colors: {
    navbar: {
      dropdown: {
        background: '#e6007e',
        text: '#ede1eb',
      },
    },
    borderSeparator: {
      default: '#272727',
    },
    highContrast: {
      primary: '#000',
      secondary: '#ffed00',
    },
    button: {
      primary: {
        default: '#009fe3',
        onHover: '#66c5ee',
        click: '#007fb6',
        disabled: '#dadada',
        text: '#ffffff',
      },
      secondary: {
        default: '#009fe3',
        onHover: '#66c5ee',
        click: '#007fb6',
        disabled: '#dadada',
        background: '#ffffff',
      },
      alert: {
        default: '#E6007E',
        onHover: '#E6007E',
        click: '#E6007E',
        disabled: '#E6007E',
        background: '#E6007E',
        text: '#ffffff',
      },
      textButton: {
        default: '#009fe3',
        onHover: '#66c5ee',
        click: '#007fb6',
        disabled: '#dadada',
        background: 'inherit',
      },
    },
    link: {
      primary: '#009fe3',
      onHover: '#66c5ee',
      click: '#007fb6',
    },
    error: '#e6007e',
    offers: {
      internship: '#005f88',
      practice: '#8a004c',
      holiday_internship: '#e6007e',
    },
    work_types: {
      office: '#005f88',
      hybrid: '#8a004c',
      remote: '#e6007e',
    },

    borders: {
      primary: '#ccecf9',
      invalid: '#e6007e',
    },
    navigationLink: {
      default: '#00202d',
      hover: '#e6007e',
    },
  },
  shadow: {
    small: '0 4px 10px 0 rgba(0, 64, 91, 0.1)',
    medium: '4px 8px 20px 0 rgba(0, 64, 91, 0.08)',
  },
  sizes: {
    button: {
      fontSize: {
        small: 11,
        medium: 14,
      },
    },
  },
  defaults: {
    fontFamily: { primary: 'Barlow', secondary: 'Raleway' },
    fontSize: 16,
    mediumFontSize: 18,
    largeFontSize: 20,
  },
  layoutMaxWidth: 1312,
};

export default defaultTheme;
